import { render, staticRenderFns } from "./BookingsTable.vue?vue&type=template&id=226fa115&scoped=true"
import script from "./BookingsTable.vue?vue&type=script&lang=js"
export * from "./BookingsTable.vue?vue&type=script&lang=js"
import style0 from "./BookingsTable.vue?vue&type=style&index=0&id=226fa115&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226fa115",
  null
  
)

export default component.exports